import { render, staticRenderFns } from "./in-salabam-slider.vue?vue&type=template&id=1cef72b2&"
import script from "./in-salabam-slider.vue?vue&type=script&lang=js&"
export * from "./in-salabam-slider.vue?vue&type=script&lang=js&"
import style0 from "./in-salabam-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports